export const ENVIRONMENT_SHORT =
  process.env.NEXT_PUBLIC_ENVIRONMENT === "production"
    ? "PRD"
    : process.env.NEXT_PUBLIC_ENVIRONMENT === "staging"
    ? "STG"
    : "LOC";

export const PUBLIC_ENV_VARS = {
  ENVIRONMENT: process.env.NEXT_PUBLIC_ENVIRONMENT,
  GTM_ID: process.env.NEXT_PUBLIC_GTM_ID,
  ENVIRONMENT_SHORT,
  SUPPORT_EMAIL: process.env.NEXT_PUBLIC_SUPPORT_EMAIL!,
};
